export default "__VITE_ASSET__24Nu6vtM__"